import { render, staticRenderFns } from "./item-summary.component.vue?vue&type=template&id=583fd59c"
import script from "./item-summary.component.ts?vue&type=script&lang=ts&external"
export * from "./item-summary.component.ts?vue&type=script&lang=ts&external"
import style0 from "./item-summary.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports